import { Component } from '@angular/core';
import { NbDialogRef,  NbDialogService } from '@nebular/theme';
import { FluxStockService } from '../../../@core/data/rest/fluxstock/fluxstock-service';
import { FactureService } from '../../../@core/data/rest/facture/facture-service';

import { FluxStock } from '../../../@core/data/model/fluxstock';
import { plainToClass } from 'class-transformer';
import { ProduitService } from '../../../@core/data/rest/produit/produit-service';
import { Produit } from '../../../@core/data/model/produit';
import { SharedMethods } from '../../../util/sharedMethods-service';
import { Validator } from '../../../@core/data/model/validator';
import { ProduitFormComponent } from '../../produit/produitform/produitform.component';
import { isDefined } from '@angular/compiler/src/util';
import { AuthService } from '../../../auth/auth.service';
import { Commande } from '../../../@core/data/model/commande';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'commande-prompt',
  templateUrl: './commandeform.component.html' ,
  styleUrls: ['./commandeform.component.scss'],
})
export class CommandeFormComponent {

  commandeedit: Commande;

  produitloading = false;
  listeProduit: Produit[];

  select: number;

  selectedItems = [];
  dropdownSettings = {};

  product: Produit[] = [];


  constructor(
      // protected dialogRef: NbDialogRef<CommandeFormComponent>,
      protected dialogRef: NbDialogRef<CommandeFormComponent>,
      public produitService: ProduitService,
      private dialogService: NbDialogService,
      public sharedMethods: SharedMethods,
      public factureService: FactureService,
      public authService: AuthService) {
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit(): void {

    this.authService.logoutEvent.subscribe(() => {

      this.dialogRef.close();

    });

    /* for ( let i = 0; i < this.produitService.produits.length; i++) {
        this.dropdownList.push({item_id: this.produitService.produits[i].id, item_text: this.produitService.produits[i].designation });
    } */


    if (this.commandeedit.id !== 0) {
        this.selectedItems = [
          this.commandeedit.produit,
        ];
    }

    this.dropdownSettings = {
    singleSelection: true,
    idField: 'id',
    textField: 'designation',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    searchPlaceholderText: 'recherche',
    noDataAvailablePlaceholderText: 'Aucune donnée trouvée',
    closeDropDownOnSelection: true,
    };

    // chargement produit
    this.getProduits();


  }

  getProduits() {


    if (this.produitService.produits === undefined) {

      this.produitService.getProduits().then( produits => {

        // this.produit = this.produitService.produits;
        // this.product = produits;
        this.loadproduit();

      });

    } else {

      this.loadproduit();

    }


  }

  loadproduit() {

    if (this.commandeedit.facture.type_facture === 'vente' ) {

        this.product = this.produitService.produits;

        // tslint:disable-next-line:no-console

    } else {

      if (this.commandeedit.facture.type_facture === 'achat' ) {

        this.product = this.commandeedit.facture.partenaire.produits;

      }

    }

  }

  onItemSelect(item: any) {

    // tslint:disable-next-line:no-console
    /* for ( let i = 0; i < this.produitService.produits.length; i++) {
      if (this.produitService.produits[i].id === item.id ) {
        this.commandeedit.produit = this.produitService.produits[i];
      }
    } */

    this.productSelected(item);

  }

  productSelected(item: any) {

    // on vide les autres valeur
    this.commandeedit.tva = undefined;
    this.commandeedit.remise = undefined;


    const index = this.produitService.produits.findIndex( prod => prod.id === item.id);

    if ( index > -1) {

      this.commandeedit.produit = this.produitService.produits[index];

      // if ( this.commandeedit.description === undefined || this.commandeedit.description === '')
      this.commandeedit.description = item.designation;

      if (this.commandeedit.facture.type_facture === 'vente') {

        // tslint:disable-next-line:no-console
        // console.log(this.fluxstockedit.facture.partenaire);

        if (!this.commandeedit.produit.is_promo && this.commandeedit.facture.partenaire !== undefined && this.commandeedit.facture.partenaire !== null && this.commandeedit.facture.partenaire.plan_tarifaire !== null && this.commandeedit.facture.partenaire.plan_tarifaire !== undefined && this.commandeedit.facture.partenaire.plan_tarifaire.tarifs !== null && this.commandeedit.facture.partenaire.plan_tarifaire.tarifs !== undefined) {

          const itemIndex = this.commandeedit.facture.partenaire.plan_tarifaire.tarifs.findIndex( elem => elem.idproduit.toString() === this.produitService.produits[index].id.toString());

          if (itemIndex > -1)
          this.commandeedit.prix_unitaire = this.commandeedit.facture.partenaire.plan_tarifaire.tarifs[itemIndex].prix;
          else
          this.commandeedit.prix_unitaire = this.produitService.produits[index].prix_detail;

        } else {

          if(this.commandeedit.produit.is_promo)
          this.commandeedit.prix_unitaire = this.produitService.produits[index].prix_promo;
          else
          this.commandeedit.prix_unitaire = this.produitService.produits[index].prix_detail;

        }



      } else {

          this.commandeedit.prix_unitaire = this.produitService.produits[index].prix_achat;

      }

      // recuperation taxes
      if ( !this.commandeedit.produit.is_emballage ) {

        /* if (this.authService.token.company.active_tva && (this.produitService.produits[index].tva === null || this.produitService.produits[index].tva === undefined)){

          this.commandeedit.tva = this.authService.token.company.tva;

        } else {

          if (this.authService.token.company.active_tva && this.produitService.produits[index].tva !== null && this.produitService.produits[index].tva !== undefined)
          this.commandeedit.tva = this.produitService.produits[index].tva;

        } */

        if (this.commandeedit.facture.type_facture === 'vente' && this.produitService.produits[index].tva !== null && this.produitService.produits[index].tva !== undefined ) {
          this.commandeedit.tva = this.produitService.produits[index].tva;
        }

        if (this.commandeedit.facture.type_facture === 'achat' && this.produitService.produits[index].tva_achat !== null && this.produitService.produits[index].tva_achat !== undefined ) {
          this.commandeedit.tva = this.produitService.produits[index].tva_achat;
        }

        if(this.commandeedit.facture.type_facture === 'vente' )
        this.commandeedit.type_calcul_tva = this.produitService.produits[index].type_calcul_tva_vente;

        if(this.commandeedit.facture.type_facture === 'achat' )
        this.commandeedit.type_calcul_tva = this.produitService.produits[index].type_calcul_tva_achat;



      }

    } else
    return;

    // this.commandeedit.produit = item;

    this.commandeedit.quantite = 1;

    // alert(JSON.stringify(item));
    // tslint:disable-next-line:no-console
    // console.log(item);

  }

  onSelectAll(items: any) {
    // tslint:disable-next-line:no-console
    console.log(items);
  }


  cancel() {
    this.dialogRef.close();
  }

  submit() {
    // validation des données
    /* const valid = this.sharedMethods.validatePartner(this.partner, this.data);
    if (valid.result === false) {
      event.confirm.reject();
      this.sharedMethods.toastShow('error', valid.title, valid.message);

      // on stop l'exécution de la methode directement
      return;
    } */
    let valid: Validator;
    valid = this.sharedMethods.validateCommande (this.commandeedit);

    if (valid.result) {

        // on vide le flux de la facture pour liberer la memoire
        this.commandeedit.facture = null;
        this.dialogRef.close(this.commandeedit);

    } else {

        this.sharedMethods.toastShow('error', valid.title, valid.message);

    }


  }

  addproduct() {

    const prod = new Produit;
    this.editProduit(prod, 'add');

  }

  editProduit(product: Produit, typeEdit: string) {

    // this.dialogIsNotShow = false;
    const closeOnBackdropClick = false;
    this.dialogService.open(ProduitFormComponent, {
      closeOnBackdropClick,
      context: {
        produitEdit : product,
      },
    }).onClose.subscribe(data => {

        if ( data !== undefined) {

          // on met à jour le produit du flux et le partenaire selectionner
          // this.commandeedit.produit = data;

          this.produitService.produits.push( plainToClass(Produit, data as object));

          this.productSelected(data);

          this.product.push(data);

          this.selectedItems = [
            data,
          ];

          this.produitService.defaultproduitCreate = data;


          /* if (typeEdit === 'update' ) {
            this.source.update(product, data);
            this.sharedMethods.sweetalert('success', ' Produit Modifié', '');
          }

          if (typeEdit === 'add' ) {
            this.source.prepend(data);
            this.sharedMethods.sweetalert('success', ' Produit créer avec succèss', '');
          } */

        }
    });

  }


}
